import { LinkToNewTab } from "components/Elements/Link/Link.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import React from "react";
import WithdrawalRequestModal from "../Modals/WithdrawalRequestModal.js";

const PayoutsHeader = ({
  userBalanceConverted,
  isActiveSub,
  bankAccounts,
  bankDisplay,
  feeSettings,
  userData,
}) => {
  const { getTextByKey } = useContent();
  const { setModal } = useModal();

  function truncateToTwoDecimals(num) {
    const str = num.toString();
    const decimalIndex = str.indexOf(".");
    if (decimalIndex === -1) return str; // No decimal point found
    return str.substring(0, decimalIndex + 3); // Extract two digits after the decimal point
  }

  return (
    <>
      {userBalanceConverted ? (
        <div className="header">
          <div className={`left-side ${!isActiveSub ? "" : "is-subsriber"}`}>
            <div className="title">
              <h1>{getTextByKey("profile-menu-jumbopay-payouts")}</h1>
              <span className="sub-title">
                {getTextByKey("payouts-subtitle-jumbopay")}
              </span>
              {bankAccounts ? (
                <div className="bank-account">
                  {getTextByKey("payouts-bank-associated")} {bankDisplay}
                </div>
              ) : (
                <div className="add-bank">
                  <LinkToNewTab page={"user/jumbopay/settings"}>
                    {getTextByKey("payouts-add-bank")}
                  </LinkToNewTab>
                </div>
              )}
            </div>
          </div>
          <div className="right-side payouts-page">
            <div
              className={`user-balance ${!isActiveSub ? "" : "subs-balance"}`}
            >
              <div className="account-balance">
                {userBalanceConverted && (
                  <>
                    <div className="inside-box">
                      <span className="text">
                        {getTextByKey("payment-available-balance")}
                      </span>
                      <span className="currency">
                        {" "}
                        ₪{" "}
                        <span className="amount">
                          {truncateToTwoDecimals(userBalanceConverted)}
                        </span>{" "}
                        ILS
                      </span>
                    </div>
                    {userBalanceConverted >= 25 ? (
                      <div
                        onClick={() =>
                          setModal(() => (
                            <WithdrawalRequestModal
                              feeSettings={feeSettings}
                              userData={userData}
                              userPhone={userData && userData.UserPhone}
                              userBalanceConverted={userBalanceConverted}
                              bankAccounts={bankAccounts}
                            />
                          ))
                        }
                        className="request-withdrawal-btn"
                      >
                        {getTextByKey("payment-request-withdrawal")}
                      </div>
                    ) : null}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="header">
          <div className="left-side">
            <div className="title">
              <h1>{getTextByKey("profile-menu-jumbopay-payouts")}</h1>
              <span className="sub-title">
                {getTextByKey("payouts-subtitle-jumbopay")}
              </span>
              {bankAccounts ? (
                <div className="bank-account">
                  {getTextByKey("payouts-bank-associated")} {bankDisplay}
                </div>
              ) : (
                <div className="add-bank">
                  <LinkToNewTab page={"user/jumbopay/settings"}>
                    {getTextByKey("payouts-add-bank")}
                  </LinkToNewTab>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PayoutsHeader;
